import { SocketManager } from '@makemydeal/dr-shared-network';
import type { SocketManagerInitConfig } from '@makemydeal/dr-shared-bff-types';

let socketManagerInstance: SocketManager | null = null;

export const getOrCreateSocketManager = (config: SocketManagerInitConfig): SocketManager => {
    if (!socketManagerInstance) {
        socketManagerInstance = new SocketManager({
            wsUrl: config.wsUrl,
            dealExchangeId: config.dealExchangeId,
            selectors: {},
            messageCallback: config.messageCallback
        });
        socketManagerInstance.start(true);

        (window as any).drSocketManager = socketManagerInstance;
    }
    return socketManagerInstance;
};

export const isSocketManagerRunning = (): boolean => socketManagerInstance !== null;
